module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@2x.5be47625.webp";